export default __webpack_public_path__ + "static/media/eye - active.ff0046df.svg";